import React from 'react';
import { PortalContext } from '../../../../../context/portal-context';
import { actionRedirect } from '../../../../../helpers/common-helpers';
import { HuchaTier } from '../../shared/models/hucha-values';
import { useHuchaTracker } from '../../shared/hooks/use-hucha-tracker';

export const useCitaHandler = (huchaTier: HuchaTier) => {
	const { userInteractionService } = React.useContext(PortalContext);
	const { trackCitaConcesionarioClick } = useHuchaTracker(huchaTier);

	const handleCita = () => {
		trackCitaConcesionarioClick();
		actionRedirect(userInteractionService, 'es-oneform--lead-cita');
	};
	return { handleCita };
};
